import React, {useEffect, useRef, useState} from 'react';
import {Form, Button, Card} from 'react-bootstrap'
import axios from 'axios';
import Popup from 'reactjs-popup';
import {useHistory} from 'react-router-dom';
import * as XLSX from 'xlsx';
import {OutTable, ExcelRenderer} from 'react-excel-renderer';
import Spreadsheet from "react-spreadsheet";
import OverLay from '../overlay';
import './stamppaper.css'
const EducatorDelight_Adminsheet=(props)=>{
    let choosexls=useRef(null)
    const history=useHistory()
    const popupmodal=useRef()
    const popupmodal_Occasion=useRef()
    const [indicator, setindecator]=useState(false)
    const [data, setdata]=useState([])
    const [SelectNoofstamppaper, setSelectnoofstamppaper]=useState('')
    const [checkrequest, setcheckedrequest]=useState(false)
    const [bulkupladdata, setbulkuploaddata]=useState(
        {xls_file:''}
    )
    const [getrequestdata, setgetrequestdata]=useState({})
    const [getrequestdata2, setgetrequestdata2]=useState({
        rows:{},
        cols:{}
    })
    
    const [spread, setspread]=useState([])
    // userData={props.userData}

    const [err, seterr]=useState({
        dataerr_0:{},
        dataerr_1:{}
    })
    const [err2, seterr2]=useState({})
    const [samedatachecked, setsamedatachecked]=useState(false);
    const [get_states, setget_states]=useState([])
    const [get_city, setget_city]=useState([])
    const [get_city1, setget_city1]=useState([])
    const [sutypeOccasion, setsubtypeOccasion]=useState([])
    const [type_of_educator, set_type_of_educator]=useState({
        top250:[],
        normal:[]
    })
    console.log('type_of_educator', type_of_educator)
    const [popupmodal_Occasion_err, setpopupmodal_Occasion_err]=useState('')
    const handleSubmit =(ev)=>{
        ev.preventDefault()
        let err={
            dataerr_0:{},
            dataerr_1:{},
        }
        data.forEach((dataval, i)=>{
            // pan_no_of_second_party
            if(!dataval.city.trim()){
                err['dataerr_'+i].city='Please Select city'
            }
            if(!dataval.state.trim()){
                err['dataerr_'+i].state='Please Select state'
            }
            // if(!dataval.Request_Date.trim()){
            //     err['dataerr_'+i].Request_Date='Please Enter Request Date'
            // }
            if(!dataval.Educator_Id.trim()){
                err['dataerr_'+i].Educator_Id='Please Enter Educator Id'
            }
            if(!dataval.Educator_Name.trim()){
                err['dataerr_'+i].Educator_Name='Please Enter Educator Name'
            }
            if(!dataval.Educator_Profile_Link_Email_Id.trim()){
                err['dataerr_'+i].Educator_Profile_Link_Email_Id='Please Enter Educator Profile Link/Email Id'
            }
            if(!dataval.Category.trim()){
                err['dataerr_'+i].Category='Please Enter Category'
            }
            if(!dataval.Director.trim()){
                err['dataerr_'+i].Director='Please Enter Director'
            }
           
            if(!dataval.Occasion.trim()){
                err['dataerr_'+i].Occasion='Please enter Occasion'
            }
           
            if(!dataval.Details_of_Occasion.trim()){
                err['dataerr_'+i].Details_of_Occasion='Please Enter Details of Occasion'
            }

            if(!dataval.Date_of_Occassion.trim()){
                err['dataerr_'+i].Date_of_Occassion='Please Enter Date of Occassion'
            }
            if(!dataval.Contact_Number.trim()){
                err['dataerr_'+i].Contact_Number='Please Enter Contact Number'
            }
            if(!dataval.Address.trim()){
                err['dataerr_'+i].Address='Please Enter Address'
            }
            // if(!dataval.Gift.trim()){
            //     err['dataerr_'+i].Gift='Please Enter Gift'
            // }
            // if(!dataval.PR_No.trim()){
            //     err['dataerr_'+i].PR_No='Please Enter PR No'
            // }
            // if(!dataval.Additonal_Item_cost.trim()){
            //     err['dataerr_'+i].Additonal_Item_cost='Please Enter Additonal Item cost'
            // }
            if(!dataval.Total_Cost.trim()){
                err['dataerr_'+i].Total_Cost='Please Enter Total Cost'
            }
            if(!dataval.Message_on_Amazon_Smoor_Card_Gift_Wrap.trim()){
                err['dataerr_'+i].Message_on_Amazon_Smoor_Card_Gift_Wrap='Please Enter Message on Amazon/Smoor Card/Gift Wrap (To be filled by Ops team)'
            }
            // if(!dataval.PO_Number.trim()){
            //     err['dataerr_'+i].PO_Number='Please Enter PO Number'
            // }
            // if(!dataval.PR_value.trim()){
            //     err['dataerr_'+i].PR_value='Please Enter PR value'
            // }
            // if(!dataval.Remarks.trim()){
            //     err['dataerr_'+i].Remarks='Please Enter Remarks'
            // }
            // pin_code
            if(!dataval.pin_code.trim()){
                err['dataerr_'+i].pin_code='Please Enter Pin Code'
            }
            // Alternative_Contact
            if(!dataval.Alternative_Contact.trim()){
                err['dataerr_'+i].Alternative_Contact='Please Enter Alternative Contact Number'
            }
            if(sutypeOccasion.length!==0){
                if(!dataval.Occation_Sub_Type.trim()){
                    err['dataerr_'+i].Occation_Sub_Type='Please Slecte Occation Sub-Type'
                }   
            }
            //Gift_link 
            // if(!dataval.Gift_link.trim()){
            //     err['dataerr_'+i].Gift_link='Please Enter Gift Link'
            // }
            if(!dataval.type_of_educator.trim()){
                err['dataerr_'+i].type_of_educator='Please Select Type of Educator'
            }
            if(!dataval.Educator_value.trim()){
                err['dataerr_'+i].Educator_value=dataval.Educator_value==='Special Category'?'Enter Educator value':'Select Educator value'
            }
            dataval.gift_details.forEach((key, j)=>{
                console.log(key)
                if(!key.Gift_Name.trim()){
                    err['dataerr_'+i]['Gift_Name'+j]='Please Enter Gift Name'
                }
                if(!key.Gift_Link.trim()){
                    err['dataerr_'+i]['Gift_Link'+j]='Please Enter Gift Link'
                }
                if(!key.Item_cost.trim()){
                    err['dataerr_'+i]['Item_cost'+j]='Please Enter Item Cost'
                }
            })
        })
        seterr({...err})
        if(Object.keys(err.dataerr_0).length===0&&Object.keys(err.dataerr_1).length===0){
            let ndata={data:data}
                ndata.user_id=props.userData.id
                ndata.scheme_id=props.userData.corporate_id

                console.log(ndata)
            setindecator(true)
            axios.post('/save_logistic_educator_delight_gifts', ndata)
            .then(res=>{
                setindecator(false)
                if(res.data){
                    setgetrequestdata(res.data)
                    popupmodal.current.open()

                }
                console.log(res.data)
            }).catch((err)=>{
                console.log(err)
                setindecator(false)
            })
        }
    }
    const handleSubmitBulkUpload =(ev)=>{
        ev.preventDefault()
        let err2={}
        if(!bulkupladdata.xls_file.trim()){
            err2.xls_file='Please Upload File'
        }
        seterr2({...err2})
        if(Object.keys(err2).length===0){
            if(Object.keys(props.userData).length!==0){
                if(props.userData.id){
                    let getrequestdata2_main=getrequestdata2
                    try{
                        getrequestdata2_main.rows.forEach((key, i)=>{
                            
                              if(i!==0){
                                key[0]=ExcelDateToJSDate(key[0]);
                                key[8]=ExcelDateToJSDate(key[8]);
                                let giftdetails=[]
                                let giftName=key[24].split(',')
                                let giftLink=key[25].split(',')
                                let itemCost=key[26].split(',')
                                for(let k=0;k<giftName.length;k++){
                                    giftdetails[k]= {
                                        Gift_Name:giftName[k],
                                        Gift_Link:giftLink[k],
                                        Item_cost:itemCost[k]
                                    }
                                }
                                key.push({'giftdetails':giftdetails})
                              }
                        })
                    }
                    catch(Err){}
                    let data=getrequestdata2
                        data.user_id=props.userData.id
                        data.scheme_id=props.userData.corporate_id
                        data.service_type=props.servicetype
                        setgetrequestdata2({...getrequestdata2, rows:{}, cols:{}})
                        if(choosexls.current!==null){
                            choosexls.current.value=""
                        }
                        setindecator(true)
                    axios.post('/bulk_upload_logistic', data)
                    .then((resp)=>{
                        setindecator(false)
                        if(resp.data){
                            setgetrequestdata(resp.data)
                            popupmodal.current.open()
                        }
                    }).catch((err)=>{
                        setindecator(false)
                    })
                }else{
                    alert('id', props.userData.id)
                }
                
            }
        }
    }
    const checkedsamedataalgo=()=>{
        let ndata=[...data]
        if(samedatachecked===false){
            ndata[1]=data[0]
        }else{
            ndata[1]= {
                service_type:props.servicetype,
                city:'',
                state:'',
                Request_Date:'',
                Educator_Id:'',
                Educator_Name:'',
                Educator_Profile_Link_Email_Id:'',
                Category:'',
                Director:'',
                Occasion:'',
                Details_of_Occasion:'',
                Date_of_Occassion:'',
                Contact_Number:'',
                Address:'',
                Gift:'',
                PR_No:'',
                PR_value:'',
                Additonal_Item_cost:'',
                Total_Cost:'',
                Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                PO_Number:'',
                fileuplaod:{},
                Remarks:'',
                Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',
                Gift_link:'',
                Alternative_Contact:'',
                pin_code:'',
                gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]
            }
        }
        setdata([...ndata])
    }
    const getBase64=(file)=>{
        return new Promise((resolve, reject)=>{
            const reader=new FileReader();
            reader.readAsDataURL(file);
            reader.onload=()=>resolve(reader.result)
            reader.onerror=error=>reject(error)
        })
    }
    const getstate=()=>{
        axios.get('/get_states').then((res)=>{
            setget_states(res.data)
        })
    }
   const getcity=(id)=>{
    setindecator(true)
       axios.get('/get_cities_by_state?stateId='+id).then((res)=>{
        setindecator(false)
           setget_city(res.data.sort(function(a, b){
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        
        }))
       }).catch((err)=>{
           if (err) throw err;
        setindecator(false)

       })
   }
   const getcity1=(id)=>{
    setindecator(true)
       axios.get('/get_cities_by_state?stateId='+id).then((res)=>{
        setindecator(false)
           setget_city1(res.data.sort(function(a, b){
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        
        }))
       }).catch((err)=>{
           if (err) throw err;
        setindecator(false)

       })
   }
   const ExcelDateToJSDate = (date) => {
    if(Number.isInteger(date)){
        let converted_date = new Date(Math.round((date - 25569) * 864e5));
        converted_date = String(converted_date).slice(4, 15)
        date = converted_date.split(" ")
        let day = date[1];
        let month = date[0];
        month = "JanFebMarAprMayJunJulAugSepOctNovDec".indexOf(month) / 3 + 1
        if (month.toString().length <= 1)
            month = '0' + month
        let year = date[2];
        return String(year.slice(0, 4)  +'-'+  month + '-' + day )
    }
}
   console.log('Educato', err)

    useEffect(()=>{
        
        getstate()
    }, [])
    return(
        <>
        <div style={{display:'flex',flexDirection:'column', alignItems:'center', justifyContent:'center'}}>
            <div>
                <label>Place Request :</label>
                <select value={SelectNoofstamppaper} onChange={(ev)=>{
                    setSelectnoofstamppaper(ev.target.value)
                    let ndata=[...data];
                    if(ev.target.value==='1'){
                        if(ndata.length>1){
                            ndata=[ndata[0]]
                        }else{
                            ndata=[{
                                service_type:props.servicetype,
                                city:'',
                                state:'',
                                Request_Date:'',
                                Educator_Id:'',
                                Educator_Name:'',
                                Educator_Profile_Link_Email_Id:'',
                                Category:'',
                                Director:'',
                                Occasion:'',
                                Details_of_Occasion:'',
                                Date_of_Occassion:'',
                                Contact_Number:'',
                                Address:'',
                                Gift:'',
                                PR_No:'',
                                PR_value:'',
                                Additonal_Item_cost:'',
                                Total_Cost:'',
                                Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                                PO_Number:'',
                fileuplaod:{},
                Remarks:'',
                Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',Gift_link:'',Alternative_Contact:'',
                pin_code:'',
                gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]
                            }]
                        }
                        setdata([...ndata])

                        setcheckedrequest(false)
                        
                    }else if(ev.target.value==='2'){
                        if(ndata.length<2){
                            ndata=[{
                                service_type:props.servicetype,
                                city:'',
                                state:'',
                                Request_Date:'',
                                Educator_Id:'',
                                Educator_Name:'',
                                Educator_Profile_Link_Email_Id:'',
                                Category:'',
                                Director:'',
                                Occasion:'',
                                Details_of_Occasion:'',
                                Date_of_Occassion:'',
                                Contact_Number:'',
                                Address:'',
                                Gift:'',
                                PR_No:'',
                                PR_value:'',
                                Additonal_Item_cost:'',
                                Total_Cost:'',
                                Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                                PO_Number:'',
                fileuplaod:{},
                Remarks:'',
                Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',Gift_link:'',Alternative_Contact:'',
                pin_code:'',
                gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]
                            },
                            {
                                service_type:props.servicetype,
                                city:'',
                                state:'',
                                Request_Date:'',
                                Educator_Id:'',
                                Educator_Name:'',
                                Educator_Profile_Link_Email_Id:'',
                                Category:'',
                                Director:'',
                                Occasion:'',
                                Details_of_Occasion:'',
                                Date_of_Occassion:'',
                                Contact_Number:'',
                                Address:'',
                                Gift:'',
                                PR_No:'',
                                PR_value:'',
                                Additonal_Item_cost:'',
                                Total_Cost:'',
                                Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                                PO_Number:'',
                fileuplaod:{},
                Remarks:'',
                Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',Gift_link:'',Alternative_Contact:'',
                pin_code:'', gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]

                            }]
                            setdata([...ndata])
                        }
                        setcheckedrequest(false)

                    }else if(ev.target.value==='3'){
                        setcheckedrequest(true)
                    }else{
                        ndata=[]
                        setdata([...ndata])
                        setcheckedrequest(false)

                    }
                
                }} style={{
                    width:200, 
                    appearance:'auto'
                }} className="form-control">
                <option key='-1' value="">Select</option>
                <option key={1} value='1'>1</option>
                <option key={2} value='2'>2</option>
                <option key={3} value="3"> { ">" }2</option>
                </select>
                <span>or</span>
                <div>
                    <input type='file' accept=".xls,.xlsx" onChange={(ev)=>{
                        if(ev.target.files[0]!==undefined){
                            let file=ev.target.files[0]
                            ExcelRenderer(file, (err, res)=>{
                                if(err){
                                    console.log(err);            
    
                                }else{
                                    console.log('excel', res)
                                    let ndata=[...data]
                                    if(res.rows.length===2){
                                        let giftdetails=[]
                                        let gift_name=res.rows[1][24].split(',')
                                        let gift_link=res.rows[1][25].split(',')
                                        let item_cost=res.rows[1][26].split(',')
                                        for(let i=0;i<gift_name.length;i++){
                                            giftdetails.push({
                                                Gift_Name:gift_name[i],
                                                Gift_Link:gift_link[i],
                                                Item_cost:item_cost[i]
                                            })
                                        }
                                        ndata=[{
                                            service_type:props.servicetype,
                                            city:res.rows[1][19],
                                            state:'',
                                            Request_Date:ExcelDateToJSDate(res.rows[1][0]),
                                            Educator_Id:res.rows[1][1],
                                            Educator_Name:res.rows[1][2],
                                            Educator_Profile_Link_Email_Id:res.rows[1][3],
                                            Category:res.rows[1][4],
                                            Director:res.rows[1][5],
                                            Occasion:res.rows[1][6],
                                            Details_of_Occasion:res.rows[1][7],
                                            Date_of_Occassion:ExcelDateToJSDate(res.rows[1][8]),
                                            Contact_Number:res.rows[1][9],
                                            Address:res.rows[1][10],
                                            Gift:res.rows[1][11],
                                            PR_No:res.rows[1][12],
                                            PR_value:res.rows[1][13],
                                            Additonal_Item_cost:res.rows[1][14],
                                            Total_Cost:res.rows[1][15],
                                            Message_on_Amazon_Smoor_Card_Gift_Wrap:res.rows[1][16],
                                            PO_Number:res.rows[1][17],
                                            fileuplaod:{},
                                            Remarks:res.rows[1][18],
                                            Occation_Sub_Type:'',
                                            type_of_educator:res.rows[1][22],
                                            Educator_value:JSON.stringify(res.rows[1][23]),
                                            Gift_link:'',Alternative_Contact:res.rows[1][19],
                                            pin_code:res.rows[1][20],
                                            gift_details:giftdetails
                                        }]
                                    setcheckedrequest(false)
    
                                        setSelectnoofstamppaper(1)
                                        
                                    }else if(res.rows.length===3){
                                        let giftdetails=[]
                                        let gift_name=res.rows[1][24].split(',')
                                        let gift_link=res.rows[1][25].split(',')
                                        let item_cost=res.rows[1][26].split(',')
                                        for(let i=0;i<gift_name.length;i++){
                                            giftdetails.push({
                                                Gift_Name:gift_name[i],
                                                Gift_Link:gift_link[i],
                                                Item_cost:item_cost[i]
                                            })
                                        }
                                        let giftdetails_2=[]
                                        let gift_name_2=res.rows[2][24].split(',')
                                        let gift_link_2=res.rows[2][25].split(',')
                                        let item_cost_2=res.rows[2][26].split(',')
                                        for(let i=0;i<gift_name.length;i++){
                                            giftdetails.push({
                                                Gift_Name:gift_name_2[i],
                                                Gift_Link:gift_link_2[i],
                                                Item_cost:item_cost_2[i]
                                            })
                                        }
                                        ndata=[{
                                            service_type:props.servicetype,
                                            city:res.rows[1][19],
                                            state:'',
                                            Request_Date:ExcelDateToJSDate(res.rows[1][0]),
                                            Educator_Id:res.rows[1][1],
                                            Educator_Name:res.rows[1][2],
                                            Educator_Profile_Link_Email_Id:res.rows[1][3],
                                            Category:res.rows[1][4],
                                            Director:res.rows[1][5],
                                            Occasion:res.rows[1][6],
                                            Details_of_Occasion:res.rows[1][7],
                                            Date_of_Occassion:ExcelDateToJSDate(res.rows[1][8]),
                                            Contact_Number:res.rows[1][9],
                                            Address:res.rows[1][10],
                                            Gift:res.rows[1][11],
                                            PR_No:res.rows[1][12],
                                            PR_value:res.rows[1][13],
                                            Additonal_Item_cost:res.rows[1][14],
                                            Total_Cost:res.rows[1][15],
                                            Message_on_Amazon_Smoor_Card_Gift_Wrap:res.rows[1][16],
                                            PO_Number:res.rows[1][17],
                                            fileuplaod:{},
                                            Remarks:res.rows[1][18],
                                            Occation_Sub_Type:'',
                                            type_of_educator:res.rows[1][22],
                                            Educator_value:res.rows[1][23],Gift_link:'',Alternative_Contact:res.rows[1][19],
                                            pin_code:res.rows[1][20],
                                            gift_details:giftdetails
                                        },
                                        {
                                            service_type:props.servicetype,
                                            city:res.rows[2][19],
                                            state:'',
                                            Request_Date:ExcelDateToJSDate(res.rows[2][0]),
                                            Educator_Id:res.rows[2][1],
                                            Educator_Name:res.rows[2][2],
                                            Educator_Profile_Link_Email_Id:res.rows[2][3],
                                            Category:res.rows[2][4],
                                            Director:res.rows[2][5],
                                            Occasion:res.rows[2][6],
                                            Details_of_Occasion:res.rows[2][7],
                                            Date_of_Occassion:ExcelDateToJSDate(res.rows[2][8]),
                                            Contact_Number:res.rows[2][9],
                                            Address:res.rows[2][10],
                                            Gift:res.rows[2][11],
                                            PR_No:res.rows[2][12],
                                            PR_value:res.rows[2][13],
                                            Additonal_Item_cost:res.rows[2][14],
                                            Total_Cost:res.rows[2][15],
                                            Message_on_Amazon_Smoor_Card_Gift_Wrap:res.rows[2][16],
                                            PO_Number:res.rows[2][17],
                                            fileuplaod:{},
                                            Remarks:res.rows[2][18],
                                            Occation_Sub_Type:"",
                                            type_of_educator:res.rows[2][22],
                                            Educator_value:res.rows[2][23],
                                            Gift_link:'',Alternative_Contact:res.rows[2][19],
                                            pin_code:res.rows[2][20],
                                            gift_details:giftdetails_2
                                        }
                                    
                                    ]
                                    setcheckedrequest(false)
    
                                        setSelectnoofstamppaper(2)
    
                                    }else{
                                        setSelectnoofstamppaper(3)
                                        setcheckedrequest(true)
                                        console.log(res.rows)
    
                                    }
                                    console.log(res.rows)
    
                                    setdata(ndata)
                                }
                            })
                        }else{
                            setdata([])
                            setSelectnoofstamppaper('')

                        }
                    }}/>
                </div>
            </div>

            <div>
                {data.length===2&&
                    <div>
                        {checkrequest===false&&
                        <div>
                            <input type={'checkbox'} checked={samedatachecked} onChange={(ev)=>{
                            setsamedatachecked(!samedatachecked)
                            checkedsamedataalgo()
                            }}  className="form-check-input"/>
                            {" "}
                            <label>
                                same as previous details
                            </label>                   
                        </div>}
                    </div>
                }
            </div>
        </div>
        {/*
            <div>
                <label style={{padding:10}}>
                    Request
                    <input onChange={()=>{
                        setcheckedrequest(false)
                    }} name='request'  type="radio" checked={checkrequest===false?true:false} />
                </label>
                <label style={{padding:10}}>
                    Bulk Uplaod
                    <input onChange={()=>{
                        setcheckedrequest(true)
                    }} name='request' type="radio" checked={checkrequest}/>
                </label>
            </div>
        */}
        {checkrequest?<div style={{padding:10}}>
            <form action='/' onSubmit={handleSubmitBulkUpload}>
                <div style={{display:'flex', alignItems:'center', justifyContent:'space-around'}}>
                    <div >
                        <input ref={choosexls} accept=".xls,.xlsx"  type="file" onChange={(ev)=>{
                            let file=ev.target.files[0]
                            ExcelRenderer(file, (err, resp) => {
                                if(err){
                                console.log(err);            
                                }
                                else{
                                    // resp.cols[8]={name:"I", key:8}
                                    // resp.rows.forEach((key, i)=>{
                                    //     if(i!==0){
                                    //         key[8]=<div key={i}>
                                    //             <label htmlFor={'choosefile'+i}>Upload File</label>
                                    //             <input id={'choosefile'+i} onChange={(ev)=>{
                                                    
                                    //                 if(ev.target.files[0]){
                                    //                     let file=ev.target.files[0]
                                    //                     let reader=new FileReader()
                                    //                     reader.onload=()=>{
                                                            
                                                            
                                    //                         if(Object.keys(resp.rows).length!==0){
                                    //                             resp.rows[i][9]=reader.result.substr(reader.result.indexOf(',') + 1)
                                    //                             resp.rows[i][10]=file.type
                                    //                             setgetrequestdata2({...getrequestdata2, rows:resp.rows, cols:resp.cols})
                                    //                             }
                                    //                     }
                                    //                     if(file){
                                    //                         reader.readAsDataURL(file)
                                    //                     }
                                    //                 }
                                    //             }}
                                    //             style={{display:'none'}} type='file' key={i}/>
                                    //         </div>
                                    //     }
                                    // })
                                   
                                    setgetrequestdata2({...getrequestdata2, rows:resp.rows, cols:resp.cols})
                                }
                            }); 
                            var reader = new FileReader();
                            // const rABS = !!reader.readAsBinaryString;
                            reader.onload = function(upload) {
                                setbulkuploaddata({...bulkupladdata, xls_file:upload.target.result})
                                // const wb=XLSX.read(upload.target.result, { type: rABS ? 'binary' : 'array', bookVBA : true });
                                // let wsname=wb.SheetNames[0]
                                // const ws=wb.Sheets[wsname]
                                // const data=XLSX.utils.sheet_to_json(ws, {header:1})
                                // setspread(data)
                                // console.log('sakmkmakaskmkasm',data)
                                // setbulkuploaddata({...bulkupladdata, xls_file:upload.target.result})

                                seterr2({...err2, xls_file:''})
                            };
                            reader.readAsDataURL(file)
                            // if (rABS) {
                            //     reader.readAsBinaryString(file);
                            //   } else {
                            //     reader.readAsArrayBuffer(file);
                            //   };
                        }}/>
                        {err2.xls_file&&
                            <span style={{color:'red'}}>{err2.xls_file}</span>
                            }
                            
                    </div>
                    <div>
                        <a style={{
                            color:'#0d6efd'
                        }} href='/download_educator'>Click to download sample file</a>
                    </div>
                </div>
                <div style={{overflow:'auto', height:300, padding:10}}>
                {Object.keys(getrequestdata2.rows).length!==0&&
                    <OutTable style={{
                        textAlign:'center',

                    }} data={getrequestdata2.rows} columns={getrequestdata2.cols} 
                    tableClassName="ExcelTable2007" tableHeaderRowClass="heading" />
                }
                </div>
                <div style={{textAlign:'center', width:'100%', paddingTop:20}}>
                    <Button type="submit" variant="warning" style={{color:'white',width:'150px', display:'inline',fontSize:20}} >Submit</Button>
                </div>
            </form>
            
            </div>:
            <form action='/' onSubmit={handleSubmit} >
            <div style={{flexDirection:'row', display:'flex', justifyContent:'space-around', padding:10}}>
                {data.map((dataval, i)=>{
                  return  <div key={i}  style={{
                  
                    display:data.length===1&&'flex',
                    flexWrap:'wrap',
                  
                    alignItems:'center',
                    justifyContent:'space-between',
                    padding:10
                }}s>
                    <div>
                    <label className='required'>Delivery State:</label>
                    <select
                    disabled={i===1&&samedatachecked}
                    value={dataval.state}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].state=ev.target.value
                            setdata([...ndata])
                        // setselectstate(ev.target.value)
                        // setdata({...data, state:ev.target.value})
                        // seterr({...err, state:''})
                        let nerr={...err}
                        err['dataerr_'+i].state=''
                        seterr({...nerr})
                        const index = ev.target.selectedIndex;
                        const el = ev.target.childNodes[index]
                        const id =  el.getAttribute('id'); 
                        if(i===0){
                            getcity(id)
                        }else{
                            getcity1(id)
                        }
                        // console.log(id)
                    }}
                    style={{
                        width:300, 
                        appearance:'auto'
                    }} className="form-control" id="4">
                    <option key='-1' value=''>Select State</option>
                    {get_states.sort(function(a, b){
                        var textA = a.name.toUpperCase();
                        var textB = b.name.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    
                    }).map((stat, i)=>{
                        return(
                            <option value={stat.name} key={i} id={stat.id}>{stat.name}</option>
                        )
                    })}
                </select>
                {err['dataerr_'+i].state&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].state}</span>
                    }
                </div>
                <div>
                    <label className='required'>Delivery City:</label>
                    {/*
                        <select
                        disabled={i===1&&samedatachecked}
                        value={dataval.city}
                        onChange={(ev)=>{
                            let ndata=[...data]
                                ndata[i].city=ev.target.value
                                setdata([...ndata])
                            // setselectstate(ev.target.value)
                            // setdata({...data, state:ev.target.value})
                            // seterr({...err, state:''})
                            let nerr={...err}
                            err['dataerr_'+i].city=''
                            seterr({...nerr})
                        }}
                        style={{
                            width:200, 
                            appearance:'auto'
                        }} className="form-control" id="1">
                        <option key='-1' value=''>Select City</option>
                        {i===0?
                            <>
                            {get_city.map((stat, i)=>{
                                return(
                                    <option value={stat.name} key={i}>{stat.name}</option>
                                )
                            })}
                            </>:
                            <>
                            {get_city1.map((stat, i)=>{
                                return(
                                    <option value={stat.name} key={i}>{stat.name}</option>
                                )
                            })}
                            </>
                        }
                    </select>
                    */}
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.city}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].city=ev.target.value
                            setdata([...ndata])
                        // seterr({...err, name_of_second_party:''})
                        let nerr={...err}
                        err['dataerr_'+i].city=''
                        seterr({...nerr})
            
                    }} name="city" className="form-control"/>
                {err['dataerr_'+i].city&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].city}</span>
                    }
                </div>
                {/*
                    <div>
                        <div>
                            <label>Event Date:</label>
                        </div>
                
                        <input style={{width:300}} type='date' disabled={i===1&&samedatachecked} value={dataval.Request_Date}
                        onChange={(ev)=>{
                            let ndata=[...data]
                                ndata[i].Request_Date=ev.target.value
                                setdata([...ndata])
                                let nerr={...err}
                                err['dataerr_'+i].Request_Date=''
                                seterr({...nerr})
                
                
                        }} name="Request_Date" className="form-control"/>
                        <div>
                            {err['dataerr_'+i].Request_Date&&
                                <span style={{color:'red'}}>{err['dataerr_'+i].Request_Date}</span>
                                }
                        </div>
                    </div>
                */}
                <div>
                    <label className='required'>Educator Id:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Educator_Id}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].Educator_Id=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].Educator_Id=''
                            seterr({...nerr})
            
            
                    }} name="Educator_Id" className="form-control"/>
                    {err['dataerr_'+i].Educator_Id&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].Educator_Id}</span>
                        }
                </div>
                <div>
                    <label className='required'>Educator Name:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Educator_Name}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].Educator_Name=ev.target.value
                            setdata([...ndata])
                        // seterr({...err, name_of_second_party:''})
                        let nerr={...err}
                        err['dataerr_'+i].Educator_Name=''
                        seterr({...nerr})
            
                    }} name="Educator_Name" className="form-control"/>
                    {err['dataerr_'+i].Educator_Name&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].Educator_Name}</span>
                        }
                </div>
                <div>
                    <label className='required'>Educator Profile Link{'/'}Email Id:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Educator_Profile_Link_Email_Id}
                    onChange={(ev)=>{
                        let ndata=[...data]
                            ndata[i].Educator_Profile_Link_Email_Id=ev.target.value
                            setdata([...ndata])
                            let nerr={...err}
                            err['dataerr_'+i].Educator_Profile_Link_Email_Id=''
                            seterr({...nerr})
            
            
                    }} name="Educator_Profile_Link_Email_Id" className="form-control"/>
                    {err['dataerr_'+i].Educator_Profile_Link_Email_Id&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].Educator_Profile_Link_Email_Id}</span>
                        }
                </div>
                <div>
                    <label className='required'>Educator's Category:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Category} 
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].Category=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, stamp_paper_value:ev.target.value})
                        // seterr({...err, stamp_paper_value:''})
                        let nerr={...err}
                        err['dataerr_'+i].Category=''
                        seterr({...nerr})
            
                    }} name='Category' className="form-control"/>
                    {err['dataerr_'+i].Category&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].Category}</span>
                        }
                </div>
                
                <div>
                    <label className='required'>Director:</label>
            
                    <input style={{width:300}} disabled={i===1&&samedatachecked} name='Director' value={dataval.Director}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].Director=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, no_of_stamp_paper:ev.target.value})
                        // seterr({...err, no_of_stamp_paper:''})
                        let nerr={...err}
                        err['dataerr_'+i].Director=''
                        seterr({...nerr})
            
                    }} className="form-control"/>
                    {err['dataerr_'+i].Director&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].Director}</span>
                        }
                </div>
                <div>
                <div>
                    <label className='required'>Occasion Type :</label>
                </div>
                {/*
                    <input style={{width:300}} disabled={i===1&&samedatachecked} name='Occasion' value={dataval.Occasion}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].Occasion=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, no_of_stamp_paper:ev.target.value})
                        // seterr({...err, no_of_stamp_paper:''})
                        let nerr={...err}
                        err['dataerr_'+i].Occasion=''
                        seterr({...nerr})
            
                    }} className="form-control"/>
                */}
                <select className='form-select' disabled={i===1&&samedatachecked}
                value={dataval.Occasion} style={{width:300}} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Occasion=ev.target.value
                    ndata[i].Occation_Sub_Type=''
                    ndata[i].type_of_educator=''
                    ndata[i].Educator_value=''
                    setdata([...ndata])
                    // setdata({...data, no_of_stamp_paper:ev.target.value})
                    // seterr({...err, no_of_stamp_paper:''})
                    // setsubtypeOccasion
                    if(ev.target.value===''){
                        setsubtypeOccasion([])
                       set_type_of_educator({...type_of_educator, normal:[], top250:[]})
                        
                    }
                    if(ev.target.value==='Birthday'){
                        setsubtypeOccasion([])
                       
                       set_type_of_educator({...type_of_educator, normal:['1500'], top250:['5000']})
                       
                       
                    }
                    if(ev.target.value==='Spouse Birthday'){
                        setsubtypeOccasion([])
                        let ntype_of_educator={...type_of_educator}
                       
                       set_type_of_educator({...type_of_educator, normal:['0'], top250:['2500']})

                        
                    }
                    if(ev.target.value==="Kid's Birthday"){
                        setsubtypeOccasion([])
                       set_type_of_educator({...type_of_educator, normal:['0'], top250:['2500']})

                    }
                    if(ev.target.value==="Marriage"){
                        setsubtypeOccasion([])
                       set_type_of_educator({...type_of_educator, normal:['10000'], top250:['10000']})

                    }
                    if(ev.target.value==='Wedding Anniversary'){
                        setsubtypeOccasion([])
                       set_type_of_educator({...type_of_educator, normal:['10000'], top250:['10000']})

                    }
                    if(ev.target.value==='Parenthood'){
                        setsubtypeOccasion([])
                        
                       set_type_of_educator({...type_of_educator, normal:['2500'], top250:['2500']})

                    }
                    if(ev.target.value==='Work Achievement'){
                        setsubtypeOccasion([
                            {label:'1 Year', value:'1 Year'},
                            {label:'2 Year', value:'2 Year'},
                            {label:'3 Year', value:'3 Year'},
                            {label:'4 Year', value:'4 Year'},
                            {label:'5 Year', value:'5 Year'},
                            {label:'6 Year', value:'6 Year'},
                            {label:'>6 Year', value:'>6 Year'},
                        ])
                     
                      

                    }
                    if(ev.target.value==='Others'){
                        setsubtypeOccasion([
                            {label:"Educator's House Warming Ceremony", value:"Educator's House Warming Ceremony"},
                            {label:"Educator's parent anniversary", value:"Educator's parent anniversary"},
                            {label:'Speedy Recovery', value:'Speedy Recovery'},
                        ])
                        
                    //    set_type_of_educator({...type_of_educator, normal:['Na', 'Na', 'Na'], top250:['Na', 'Na', 'Na']})

                    }

                    let nerr={...err}
                    err['dataerr_'+i].Occasion=''
                    err['dataerr_'+i].Occation_Sub_Type=''
                    seterr({...nerr})
        
                }}>
                    <option value=''>Select Occasion Type</option>
                    <option>Birthday</option>
                    <option>Spouse Birthday</option>
                    <option>Kid's Birthday</option>
                    <option>Marriage</option>
                    <option>Wedding Anniversary</option>
                    <option>Parenthood</option>
                    <option>Work Achievement</option>
                    <option>Others</option>
                </select>
                {err['dataerr_'+i].Occasion&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Occasion}</span>
                    }
            </div>
            {sutypeOccasion.length!==0&&
                <div>
                    <div>
                        <label className='required'>Occasion Sub-Type</label>
                    </div>
                    <select value={dataval.Occation_Sub_Type}
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].Occation_Sub_Type=ev.target.value
                        ndata[i].Educator_value=''
                         ndata[i].type_of_educator=''

                        if(ev.target.value===''){
                            set_type_of_educator({...type_of_educator, normal:[],
                            top250:[]})
                           
                        }
                        if(ev.target.value==='1 Year'){
                            set_type_of_educator({...type_of_educator, normal:['1000'],
                                top250:['1000']})
                        }
                        if(ev.target.value==='2 Year'){
                            set_type_of_educator({...type_of_educator, normal:['5000'],
                                top250:['5000']})
                        }
                        if(ev.target.value==='3 Year'){
                            set_type_of_educator({...type_of_educator, normal:['5000'],
                                top250:['5000']})
                        }
                        if(ev.target.value==='4 Year'){
                            set_type_of_educator({...type_of_educator, normal:['7500'],
                                top250:['7500']})
                        }
                        if(ev.target.value==='5 Year'){
                            set_type_of_educator({...type_of_educator, normal:['7500'],
                                top250:['7500']})
                        }
                        if(ev.target.value==='6 Year'){
                            set_type_of_educator({...type_of_educator, normal:['7500'],
                                top250:['7500']})
                        }
                        if(ev.target.value==='>6 Year'){
                            set_type_of_educator({...type_of_educator, normal:['7500'],
                                top250:['7500']})
                        }
                        if(ev.target.value==="Educator's House Warming Ceremony"){
                            set_type_of_educator({...type_of_educator, normal:['Na'],
                                top250:['Na']})
                        }
                        if(ev.target.value==="Educator's parent anniversary"){
                            set_type_of_educator({...type_of_educator, normal:['Na'],
                                top250:['Na']})
                        }
                        if(ev.target.value==='Speedy Recovery'){
                            set_type_of_educator({...type_of_educator, normal:['Na'],
                                top250:['Na']})
                        }
                        setdata([...ndata])

                        // setpopupmodal_Occasion_err('ICP 250 is range from 1600-5000')
                        // popupmodal_Occasion.current.open()
                        // setdata({...data, stamp_paper_value:ev.target.value})
                        // seterr({...err, stamp_paper_value:''})
                        let nerr={...err}
                        err['dataerr_'+i].Occation_Sub_Type=''
                        seterr({...nerr})
            
                    }}
                    className='form-select' style={{width:300}} >
                        <option key={-1} value={''}>Select Occation Sub-Type</option>
                        {sutypeOccasion.map((octype, i)=>{
                            return(
                                <option key={i} value={octype.value}>{octype.label}</option>
                            )
                        })}
                    </select>
                    <div>
                        {err['dataerr_'+i].Occation_Sub_Type&&
                        <span style={{color:'red'}}>{err['dataerr_'+i].Occation_Sub_Type}</span>
                        }
                    </div>
                </div>
            }
            {type_of_educator.normal.length!==0&&type_of_educator.top250.length!==0&&
                <div>
                    <div>
                        <label className='required'>Type of Educator :</label>
                    </div>
                    <select value={dataval.type_of_educator}
                        onChange={(ev)=>{
                            let ndata=[...data]
                            ndata[i].type_of_educator=ev.target.value
                            ndata[i].Educator_value=''
                            if(ev.target.value==='Top 250'){
                                ndata[i].Educator_value=type_of_educator.top250[0]
                            }
                            if(ev.target.value==='Normal'){
                                ndata[i].Educator_value=type_of_educator.normal[0]
                            }
                            setdata([...ndata])
                            
                           
                            // setdata({...data, stamp_paper_value:ev.target.value})
                            // seterr({...err, stamp_paper_value:''})
                            let nerr={...err}
                            err['dataerr_'+i].type_of_educator=''
                            seterr({...nerr})
                
                        }}
                        className='form-select' style={{width:300}} >
                            <option key={-1} value={''}>Select Type of Educator</option>
                             <option value='Top 250'>Top 250</option>
                             <option value='Normal'>Normal</option>
                             <option value='Special Category'>Special Category</option>
                        </select>
                        <div>
                            {err['dataerr_'+i].type_of_educator&&
                            <span style={{color:'red'}}>{err['dataerr_'+i].type_of_educator}</span>
                            }
                        </div>
                </div>
            }
            {dataval.type_of_educator!==''&&
                <div>
                    <div>
                        <label className='required'>Educator Budget</label>
                    </div>
                    {dataval.type_of_educator==='Normal'&&
                        
                        <div>
                        <input
                        disabled={true}
                        value={dataval.Educator_value} className='form-control' style={{width:300}}/>
                            {/*
                                <select onChange={(ev)=>{
                                    // Educator_value
                                    let ndata=[...data]
                                ndata[i].Educator_value=ev.target.value
                                setdata([...ndata])
                                
                               
                                // setdata({...data, stamp_paper_value:ev.target.value})
                                // seterr({...err, stamp_paper_value:''})
                                let nerr={...err}
                                err['dataerr_'+i].Educator_value=''
                                seterr({...nerr})
                                }} className='form-select' style={{width:300}}>
                                <option key={-1} value={''}>Select Educator value</option>
    
                                    {type_of_educator.normal.map((val, j)=>{
                                        return(
                                            <option key={j} value={val}>{val}</option>
                                        )
                                    })}
                                </select>
                            */}
                        </div>
                    }
                    {dataval.type_of_educator==='Top 250'&&
                        <div>
                        <input
                        disabled={true}
                        value={dataval.Educator_value} className='form-control' style={{width:300}}/>
                            {/*
                                <select
                                onChange={(ev)=>{
                                    // Educator_value
                                    let ndata=[...data]
                                ndata[i].Educator_value=ev.target.value
                                setdata([...ndata])
                                
                               
                                // setdata({...data, stamp_paper_value:ev.target.value})
                                // seterr({...err, stamp_paper_value:''})
                                let nerr={...err}
                                err['dataerr_'+i].Educator_value=''
                                seterr({...nerr})
                                }}
                                 className='form-select' style={{width:300}}>
                                <option key={-1} value={''}>Select Educator value</option>
    
                                    {type_of_educator.top250.map((val, j)=>{
                                        return(
                                            <option key={j} value={val}>{val}</option>
                                        )
                                    })}
                                </select>
                            */}
                        </div>
                    }
                    {dataval.type_of_educator==='Special Category'&&
                        <div>
                            <input
                            onChange={(ev)=>{
                                // Educator_value
                                let ndata=[...data]
                            ndata[i].Educator_value=ev.target.value
                            setdata([...ndata])
                            
                           
                            // setdata({...data, stamp_paper_value:ev.target.value})
                            // seterr({...err, stamp_paper_value:''})
                            let nerr={...err}
                            err['dataerr_'+i].Educator_value=''
                            seterr({...nerr})
                            }} className='form-control' style={{width:300}}/>
                        </div>
                    }
                    {err['dataerr_'+i].Educator_value&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Educator_value}</span>
                    }
                </div>

            }
            <div>
                <label className='required'>Details of Occasion:</label>
        
                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Details_of_Occasion} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Details_of_Occasion=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].Details_of_Occasion=''
                    seterr({...nerr})
        
                }} name='Details_of_Occasion' className="form-control"/>
                {err['dataerr_'+i].Details_of_Occasion&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Details_of_Occasion}</span>
                    }
            </div>
            <div>
                <div>
                    <label className='required'>Date of Occassion:</label>
                </div>
                <div>
                    <input type='date' style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Date_of_Occassion} 
                    onChange={(ev)=>{
                        let ndata=[...data]
                        ndata[i].Date_of_Occassion=ev.target.value
                        setdata([...ndata])
                        // setdata({...data, stamp_paper_value:ev.target.value})
                        // seterr({...err, stamp_paper_value:''})
                        let nerr={...err}
                        err['dataerr_'+i].Date_of_Occassion=''
                        seterr({...nerr})
            
                    }} name='Date_of_Occassion' className="form-control"/>
                </div>
                {err['dataerr_'+i].Date_of_Occassion&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Date_of_Occassion}</span>
                    }
            </div>
            <div>
                <label className='required'>Contact Number:</label>
        
                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Contact_Number} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Contact_Number=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].Contact_Number=''
                    seterr({...nerr})
        
                }} name='Contact_Number' className="form-control"/>
                {err['dataerr_'+i].Contact_Number&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Contact_Number}</span>
                    }
            </div>
            <div>
                <label className='required'>RM's contact:</label>
        
                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Alternative_Contact} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Alternative_Contact=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].Alternative_Contact=''
                    seterr({...nerr})
        
                }} name='Contact_Number' className="form-control"/>
                {err['dataerr_'+i].Alternative_Contact&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Alternative_Contact}</span>
                    }
            </div>
            
            <div>
                <label className='required'>Address:</label>
        
                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Address} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Address=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].Address=''
                    seterr({...nerr})
        
                }} name='Address' className="form-control"/>
                {err['dataerr_'+i].Address&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Address}</span>
                    }
            </div>
            <div>
                <label className='required'>Pin Code:</label>
        
                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.pin_code} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].pin_code=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].pin_code=''
                    seterr({...nerr})
        
                }} name='Contact_Number' className="form-control"/>
                {err['dataerr_'+i].pin_code&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].pin_code}</span>
                    }
            </div>
            <div>
                <label className='required'>Message on Amazon{'/'}Smoor Card{"/"}Gift<br/>Wrap (To be filled by Ops team):</label>

                <textarea style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Message_on_Amazon_Smoor_Card_Gift_Wrap} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Message_on_Amazon_Smoor_Card_Gift_Wrap=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].Message_on_Amazon_Smoor_Card_Gift_Wrap=''
                    seterr({...nerr})

                }} name='Message_on_Amazon_Smoor_Card_Gift_Wrap' className="form-control"/>
                {err['dataerr_'+i].Message_on_Amazon_Smoor_Card_Gift_Wrap&&
                    <span style={{color:'red', 
                display:'block', width:300, wordBreak:'break-word'}}>{err['dataerr_'+i].Message_on_Amazon_Smoor_Card_Gift_Wrap}</span>
                    }
            </div>
            <div style={{
                display:'flex',
                flexDirection:'column',
                alignItems:'center',
                justifyContent:'space-between',
                width:'100%'
        }}>
                {dataval.gift_details.map((gift_val, j)=>{
                    console.log('gift_val', gift_val)
                return(
                    <div key={j} style={{display:'flex', flexDirection:'column', width:"100%"}}>
                    <div style={{
                        alignItems:'center',
                        display:'flex',
                        flexDirection:data.length===1?'row':'column',
                        justifyContent:'space-between',
                        width:'100%',
                    }}>
                            <div>
                                <br/>
                                <span>{j+1}.&nbsp; &nbsp;</span>
                            </div>
                            <div>
                                <label className='required'>Gift Name:</label>
                        
                                <input style={{width:300}} disabled={i===1&&samedatachecked} 
                                value={gift_val.Gift_Name} 
                                onChange={(ev)=>{
                                    let ndata=[...data]
                                    ndata[i].gift_details[j].Gift_Name=ev.target.value
                                    setdata([...ndata])
                                    // setdata({...data, stamp_paper_value:ev.target.value})
                                    // seterr({...err, stamp_paper_value:''})
                                    let nerr={...err}
                                    err['dataerr_'+i]['Gift_Name'+j]=''
                                    seterr({...nerr})
                        
                                }} name='Gift' className="form-control"/>
                                {/*
                                */}
                                {err['dataerr_'+i]['Gift_Name'+j]&&
                                    <span style={{color:'red'}}>{err['dataerr_'+i]['Gift_Name'+j]}</span>
                                    }
                            </div>
                            <div>
                                <label className='required'>Gift Link:</label>
                        
                                <input style={{width:300}} disabled={i===1&&samedatachecked} value={gift_val.Gift_Link} 
                                onChange={(ev)=>{
                                    let ndata=[...data]
                                    ndata[i].gift_details[j].Gift_Link=ev.target.value
                                    setdata([...ndata])
                                    // setdata({...data, stamp_paper_value:ev.target.value})
                                    // seterr({...err, stamp_paper_value:''})
                                    let nerr={...err}
                                    err['dataerr_'+i]['Gift_Link'+j]=''
                                    seterr({...nerr})
                        
                                }} name='Gift_link' className="form-control"/>
                                {err['dataerr_'+i]['Gift_Link'+j]&&
                                    <span style={{color:'red'}}>{err['dataerr_'+i]['Gift_Link'+j]}</span>
                                    }

                            </div>
                            
                            <div>
                                <label className='required'>Item cost:</label>
            
                                <input style={{width:300}} disabled={i===1&&samedatachecked} value={gift_val.Item_cost} 
                                onChange={(ev)=>{
                                    let ndata=[...data]
                                    ndata[i].gift_details[j].Item_cost=ev.target.value
                                    let total_cost=0
                                    ndata[i].gift_details.forEach((key)=>{
                                    //    console.log(key.Item_cost, total_cost)
                                        total_cost+=parseInt(key.Item_cost)
                                    })
                                    // console.log(typeof(total_cost))
                                    if(!isNaN(total_cost)){
                                        ndata[i].Total_Cost=total_cost.toString()
                                    }else{
                                        ndata[i].Total_Cost=''
                                    }
                                    console.log(total_cost)
                                    setdata([...ndata])
                                    // setdata({...data, stamp_paper_value:ev.target.value})
                                    // seterr({...err, stamp_paper_value:''})
                                    let nerr={...err}
                                    err['dataerr_'+i]['Item_cost'+j]=''
                                    err['dataerr_'+i].Total_Cost=''
                                    seterr({...nerr})

            
                                }} name='Additonal_Item_cost' className="form-control"/>
                                {err['dataerr_'+i]['Item_cost'+j]&&
                                    <span style={{color:'red'}}>{err['dataerr_'+i]['Item_cost'+j]}</span>
                                    }

                            </div>
                            <div>
                            <br/>
                            {data[i].gift_details.length>1&&
                                <span
                                onClick={()=>{
                                    let ndata=[...data]
                                    let fildata=ndata[i].gift_details
                                    if(ndata[i].gift_details.length>1){
                                        fildata.splice(j, 1)
                                        ndata[i].gift_details=fildata
                                        setdata(ndata)
                                    }
                                }}
                               style={{fontSize:30,  cursor:'pointer'}}>&nbsp;&nbsp;&times;</span>
                            }   
                            </div>
                        </div>
                    </div>
                )
            })} 
            {data[i].gift_details.length<=7&&
                <div>
                    <br/>
                    <span style={{
                        cursor:'pointer'
                    }} onClick={()=>{
                        let ndata=[...data]
                        ndata[i].gift_details.push( {
                            Gift_Name:'',
                            Gift_Link:'',
                            Item_cost:''
                        })
                        setdata(ndata)
                        console.log('ddjd')
                    }} className='btn btn-secondary'>+</span>     
                </div> 
            }
            </div>
            <div>
                <label className='required'>Total Cost:</label>

                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Total_Cost} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].Total_Cost=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].Total_Cost=''
                    seterr({...nerr})

                }} name='Total_Cost' className="form-control"/>
                {err['dataerr_'+i].Total_Cost&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].Total_Cost}</span>
                    }
            </div>
            <div style={{
                display:'flex',
                flexDirection:data.length===1?'row':'column',
                
                alignItems:'center',
                justifyContent:'space-between',
                width:'100%'
            }}>
            <div>
                <label >PR No:</label>
        
                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.PR_No} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].PR_No=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].PR_No=''
                    seterr({...nerr})
        
                }} name='PR_No' className="form-control"/>
                {err['dataerr_'+i].PR_No&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].PR_No}</span>
                    }
            </div>
            <div>
                <label>PR value:</label>

                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.PR_value} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].PR_value=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].PR_value=''
                    seterr({...nerr})

                }} name='PR_value' className="form-control"/>
                {err['dataerr_'+i].PR_value&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].PR_value}</span>
                    }
            </div>
            <div>
                <label>PO Number:</label>

                <input style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.PO_Number} 
                onChange={(ev)=>{
                    let ndata=[...data]
                    ndata[i].PO_Number=ev.target.value
                    setdata([...ndata])
                    // setdata({...data, stamp_paper_value:ev.target.value})
                    // seterr({...err, stamp_paper_value:''})
                    let nerr={...err}
                    err['dataerr_'+i].PO_Number=''
                    seterr({...nerr})

                }} name='PO_Number' className="form-control"/>
                {err['dataerr_'+i].PO_Number&&
                    <span style={{color:'red'}}>{err['dataerr_'+i].PO_Number}</span>
                    }
            </div>
            </div>
            {/*
                <div style={{paddingTop:15}}>
                <input
                id="image-file" disabled={i===1&&samedatachecked} type="file" 
                 accept="application/pdf,application/vnd.ms-excel, image/gif, image/jpeg, image/png,.xls,.xlsx" 
                 onChange={(ev)=>{
                    let base64File={}
                    let file=null;
                    file=ev.target.files
                        for(let k=0;k<file.length;k++){
                            // console.log(file[k].type)
                            getBase64(file[k]).then((res)=>{
                                base64File['file_'+k]={data:res.substr(res.indexOf(',') + 1), type:file[k].type}
                            })
                    } 
                    let ndata=[...data]
                    ndata[i].fileuplaod=base64File;
                    setdata([...ndata])
                }}/>  
            </div>
            */}
        <div>
        <label>Remarks:</label>

        <textarea style={{width:300}} disabled={i===1&&samedatachecked} value={dataval.Remarks}
        onChange={(ev)=>{
            let ndata=[...data]
                ndata[i].Remarks=ev.target.value
                setdata([...ndata])
                let nerr={...err}
                err['dataerr_'+i].Remarks=''
                seterr({...nerr})


        }} name="Remarks" className="form-control"/>
        {err['dataerr_'+i].Remarks&&
            <span style={{color:'red'}}>{err['dataerr_'+i].Remarks}</span>
            }
    </div>
                </div>
                })}
                </div>
                
                {SelectNoofstamppaper!==''&&
                <div style={{textAlign:'center', width:'100%', paddingTop:20}}>
                    <Button type="submit" variant="warning" style={{color:'white',width:'150px', display:'inline', fontSize:20}} >Submit</Button>
                </div>
                }
            </form>
        }
        <Popup
        
                ref={popupmodal_Occasion}
                // trigger={<button className="button"> Open Modal </button>}
                modal
                nested>
                {close=>(
                    <div>
                        <div style={{
                            textAlign:'right'
                        }}>
                            <Button
                            style={{
                                border:0,
                                borderBottom:0,
                                background:'transparent',
                                color:'grey',
                                
                            }} onClick={close}>
                                <span style={{
                                    borderBottom:'1px solid blue'
                                }}>close</span>
                            </Button>
                        </div>
                        <div>
                            <span>{popupmodal_Occasion_err}</span>
                        </div>
                    </div>
                )}
        </Popup>
            <Popup
                ref={popupmodal}
                // trigger={<button className="button"> Open Modal </button>}
                modal
                nested>
                {close => (
                    <div>
                        {getrequestdata.message&&
                            <h6 style={{
                                padding:33,
                                color:'blueviolet'
                            }}>Created with Request ID {getrequestdata.text}</h6>
                        }
                      <div style={{display:'flex',alignItems:'center', justifyContent:'space-around'}}>
                            <Button onClick={()=>{
                                close()
                                if(JSON.parse(SelectNoofstamppaper)===1){
                                    setdata([
                                        {
                                            service_type:props.servicetype,
                                            city:'',
                                            state:'',
                                            Request_Date:'',
                                            Educator_Id:'',
                                            Educator_Name:'',
                                            Educator_Profile_Link_Email_Id:'',
                                            Category:'',
                                            Director:'',
                                            Occasion:'',
                                            Details_of_Occasion:'',
                                            Date_of_Occassion:'',
                                            Contact_Number:'',
                                            Address:'',
                                            Gift:'',
                                            PR_No:'',
                                            PR_value:'',
                                            Additonal_Item_cost:'',
                                            Total_Cost:'',
                                            Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                                            PO_Number:'',
                fileuplaod:{},
                Remarks:'',
                Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',Gift_link:'',Alternative_Contact:'',pin_code:'',
                gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]

                                        }
                                    ])
                                }
                                else if(JSON.parse(SelectNoofstamppaper)===2){
                                    setdata([
                                        {
                                            service_type:props.servicetype,
                                            city:'',
                                            state:'',
                                            Request_Date:'',
                                            Educator_Id:'',
                                            Educator_Name:'',
                                            Educator_Profile_Link_Email_Id:'',
                                            Category:'',
                                            Director:'',
                                            Occasion:'',
                                            Details_of_Occasion:'',
                                            Date_of_Occassion:'',
                                            Contact_Number:'',
                                            Address:'',
                                            Gift:'',
                                            PR_No:'',
                                            PR_value:'',
                                            Additonal_Item_cost:'',
                                            Total_Cost:'',
                                            Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                                            PO_Number:'',
                fileuplaod:{},
                Remarks:'',
                Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',
                Gift_link:'',Alternative_Contact:'',pin_code:'',
                gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]
                                        },
                                        {
                                            service_type:props.servicetype,
                                            city:'',
                                            state:'',
                                            Request_Date:'',
                                            Educator_Id:'',
                                            Educator_Name:'',
                                            Educator_Profile_Link_Email_Id:'',
                                            Category:'',
                                            Director:'',
                                            Occasion:'',
                                            Details_of_Occasion:'',
                                            Date_of_Occassion:'',
                                            Contact_Number:'',
                                            Address:'',
                                            Gift:'',
                                            PR_No:'',
                                            PR_value:'',
                                            Additonal_Item_cost:'',
                                            Total_Cost:'',
                                            Message_on_Amazon_Smoor_Card_Gift_Wrap:'',
                                            PO_Number:'',
                fileuplaod:{},
                Remarks:'',Occation_Sub_Type:'',
                type_of_educator:'',
                Educator_value:'',
                Gift_link:'',Alternative_Contact:'',pin_code:'', gift_details:[
                    {
                        Gift_Name:'',
                        Gift_Link:'',
                        Item_cost:''
                    }
                ]

                                        }
                                    ])
                                }
                            }}>Continue</Button>
                            <Button onClick={()=>{
                                history.push('/reports')
                            }}>Go To The Reports</Button>
                        </div>
                    </div>
                  )}
               
            </Popup>
                <OverLay active={indicator}/>
        </>
    )
}
export default EducatorDelight_Adminsheet;